import { Injectable } from '@angular/core';
import { FilterCriteria } from '@shared/components/filters/Domain/filter.model';

@Injectable({ providedIn: 'root' })
export class FilterStorageService {
  save(key: string, data: FilterCriteria) {
    try {
      const safeData = JSON.stringify(data);
      localStorage.setItem(key, safeData);
    } catch (error) {
      console.error('Failed to save filter to localStorage:', error);
    }
  }

  cleanCircular(obj: any): any {
    if (Array.isArray(obj)) {
      return obj.map((item) => this.cleanCircular(item));
    } else if (obj && typeof obj === 'object') {
      const copy: any = {};
      Object.entries(obj).forEach(([k, v]) => {
        if (k !== 'parent' && k !== 'children') {
          copy[k] = this.cleanCircular(v);
        }
      });
      return copy;
    }
    return obj;
  }

  saveComposedFilter(key: string, value: any) {
    try {
      const cleanedValue = this.cleanCircular(value);
      localStorage.setItem(key, JSON.stringify(cleanedValue));
    } catch (e) {
      console.error('Failed to save filter to localStorage:', e);
    }
  }

  load(key: string): FilterCriteria | null {
    const stored = localStorage.getItem(key);
    return stored ? JSON.parse(stored) : null;
  }

  clear(key: string): void {
    localStorage.removeItem(key);
  }
}
